import React from 'react';
import PropTypes from 'prop-types';

/**
 * Checkbox - A wrapper that renders a standard HTML input[type="checkbox"] with Bulma checkbox class names
 * 
 * This component accepts the same props as Bloomer Checkbox for easy migration
 */
const Checkbox = ({
  className,
  style,
  children,
  checked,
  defaultChecked,
  disabled,
  onChange,
  value,
  name,
  id,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['checkbox'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <label 
      className={getClassNames()} 
      style={style}
    >
      <input 
        type="checkbox"
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        value={value}
        name={name}
        id={id}
        {...props}
      />
      {children}
    </label>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  name: PropTypes.string,
  id: PropTypes.string
};

Checkbox.defaultProps = {
  className: '',
  style: {},
  children: null,
  checked: undefined,
  defaultChecked: undefined,
  disabled: false,
  onChange: () => {},
  value: '',
  name: '',
  id: ''
};

export default Checkbox;
